import React from "react";
import { Proyectos } from "./styled";

export const Proyecto = () => {
  return (
    <>
      <Proyectos>PROYECTOS</Proyectos>
    </>
  );
};
